import isEmpty from "lodash/isEmpty";

export const getUrl = (that, searched = false) => {
  const { props, state } = that;
  let params = {};
  let url = props.dataURL;
  if (!isEmpty(props.dataParams)) params = props.dataParams;
  if (!isEmpty(props.tabs)) {
    let tab = {};
    tab = props.tabs.filter(m => m.key == state.activeKey)[0];
    if (searched) {
      props.tabs.forEach(t => {
        if (t.isSearch) {
          tab = t;
          that.setState({ activeKey: t.key });
        }
      });
    }
    if (tab && tab.url) {
      url = tab.url;
    }
    if (tab && !isEmpty(tab.dataParams)) {
      params = { ...params, ...tab.dataParams };
    }
  }
  return {
    url,
    params
  };
};

export function getValueWarp(browserProps) {
  if (!browserProps) return false;
  const { type, isSingle, dataParams } = browserProps;
  const types = window.ecBrowserDisplayStyle || [];
  let valueWarp;
  if (isSingle) {
    valueWarp = false;
  } else if (type === 162 || type === "162") {
    // 自定义多选
    valueWarp = types.indexOf(`${dataParams.type}`) !== -1;
  } else if (type === 257 || type === "257") {
    // 自定义树形多选
    valueWarp = types.indexOf(`tree.${dataParams.treeid}`) !== -1;
  } else {
    // 其他多选浏览按钮
    valueWarp = types.indexOf(`${type}`) !== -1;
  }
  return valueWarp;
}

// 获取浏览按钮每页显示条数
export function getPageSize(browserProps) {
  if (!browserProps) return false;
  const { type, dataParams } = browserProps;
  const configList = window.ecBrowserDisplayConfigList || [];
  const defaultPageSize = window.ecBrowserDisplayPageSize || 10;
  let pageSize = defaultPageSize;
  configList.map(item => {
    if (item.browserType == type) {
      pageSize = item.pageSize;
    } else if (type == 161 || type == 162) {
      if (item.browserType == dataParams.type) {
        pageSize = item.pageSize;
      }
    }
  });
  return pageSize;
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser/coms/util.js